export default __webpack_public_path__ + "static/media/CNo.73-5.ce140a7e.jpg";